<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration"><router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span><span class="decoration">Employee</span><span class="pfimg3"><i class="fa fa-angle-right"></i></span><span class="decoration">Training</span><span class="pfimg3"><i class="fa fa-angle-right"></i></span>Employee Training Requirement</h6>
      <div class="container-fluid mt-2"><employee-training-requirements :standalone="true"></employee-training-requirements></div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';
import EmployeeTrainingRequirements from './EmployeeTrainingRequirements.vue';

export default {
  components: { TopNavbar, ContentFooter, EmployeeTrainingRequirements },
  methods: { goBack() { this.$router.push('/tinternalcourses/scheduled'); } },
};
</script>
